import { AppStates } from '../reducers/app';
import { ViewState } from '../reducers/view';
import * as ViewAction from '../actions/ViewAction';
import { Action, Store, Dispatch } from 'redux';

const inertiaPanelExists = (view: ViewState): boolean => {
  for (const panelID in view.tabStates) {
    if (view.tabStates[panelID].work.type === 'inertia') {
      return true;
    }
  }
  return false;
};

const postAnimationFrameIfNeeded = (view: ViewState, dispatch: Dispatch<Action>): void => {
  if (inertiaPanelExists(view)) {
    requestAnimationFrame(() => dispatch(ViewAction.animationFrame()));

    // Simulate low spec device:
    // setTimeout(() => { dispatch(ViewAction.animationFrame()); }, 100);
  }
};

export const initAnimationFrameTrigger = (store: Store<AppStates>) => {
  let prevViewState: ViewState | null = null;

  store.subscribe(() => {
    const newState = store.getState().view;
    if (newState !== prevViewState) {
      postAnimationFrameIfNeeded(newState, store.dispatch);
      prevViewState = newState;
    }
  });
};
